import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import CloudOptixConfigListing from './CloudOptixConfigListing';
import CloudOptixCredentialForm from './CloudOptixCredentialForm';

export default function CloudOptixPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={CloudOptixCredentialForm}
            PullConfigListingView={CloudOptixConfigListing}
        />
    )
}